import ApiClient from 'clients/api_client'
import From from 'entities/mail_from'

export default class FromClient {
  static createFrom(formData) {
    const url = Routes.mailFromsPath()
    return ApiClient.post(url, formData).then(({ data }) => new From(data))
  }

  static updateFrom(id, formData) {
    const url = Routes.mailFromPath(id)
    return ApiClient.patch(url, formData).then(({ data }) => new From(data))
  }

  static deleteFrom(id) {
    const url = Routes.mailFromPath(id)
    return ApiClient.delete(url)
  }
}
